var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcn30Day(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 50 0)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.966 38H14.034A2.037 2.037 0 0112 35.966V15.66c0-1.122.913-2.035 2.035-2.035h21.93c1.122 0 2.035.913 2.035 2.035v20.306A2.036 2.036 0 0135.966 38zm-21.93-22.75a.412.412 0 00-.411.41v20.306c0 .225.184.41.41.41h21.93a.41.41 0 00.41-.41V15.66a.412.412 0 00-.41-.41h-21.93zm23.152 4.875H12.813a.812.812 0 110-1.625h24.375a.812.812 0 110 1.625zm-20.313-3.25a.812.812 0 01-.812-.813v-3.25a.812.812 0 111.625 0v3.25a.812.812 0 01-.813.813zm16.25 0a.812.812 0 01-.812-.813v-3.25a.812.812 0 111.625 0v3.25a.812.812 0 01-.813.813z",
    fill: "#01A847",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27c0 1.333-2 1.333-2 0s2-1.333 2 0M18 30c0 1.333-2 1.333-2 0s2-1.333 2 0M18 33c0 1.333-2 1.333-2 0s2-1.333 2 0M31 23c0 1.333-2 1.333-2 0s2-1.333 2 0M31 27c0 1.333-2 1.333-2 0s2-1.333 2 0M31 30c0 1.333-2 1.333-2 0s2-1.333 2 0M31 33c0 1.333-2 1.333-2 0s2-1.333 2 0M34 23c0 1.333-2 1.333-2 0s2-1.333 2 0M34 27c0 1.333-2 1.333-2 0s2-1.333 2 0M34 30c0 1.333-2 1.333-2 0s2-1.333 2 0M24 23c0 1.333-2 1.333-2 0s2-1.333 2 0M24 27c0 1.333-2 1.333-2 0s2-1.333 2 0M24 30c0 1.333-2 1.333-2 0s2-1.333 2 0M24 33c0 1.333-2 1.333-2 0s2-1.333 2 0M21 23c0 1.333-2 1.333-2 0s2-1.333 2 0M21 27c0 1.333-2 1.333-2 0s2-1.333 2 0M21 30c0 1.333-2 1.333-2 0s2-1.333 2 0M21 33c0 1.333-2 1.333-2 0s2-1.333 2 0M28 23c0 1.333-2 1.333-2 0s2-1.333 2 0M28 27c0 1.333-2 1.333-2 0s2-1.333 2 0M28 30c0 1.333-2 1.333-2 0s2-1.333 2 0M28 33c0 1.333-2 1.333-2 0s2-1.333 2 0",
    fill: "#01A847",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#01A847",
    strokeWidth: 2,
    cx: 25,
    cy: 25,
    r: 24
  }))));
}

export default SvgIcn30Day;